import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Backdrop, Box, Button, CircularProgress, Grid, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import Error from '../../../../components/error/error';
import { AllRoles } from '../../../../network/APIs/APIs';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCFCLevelsAPI, allCompaniesAPI, allEmployeeRoleTypes } from '../../../../services/Functions';
import { passwordRegex } from '../../../../utils/PortalName';
import UserIconImage from '../../../../images/user.jpg'; 


const initialValues = {
  iv_type: '1',
  iv_office_code: '',
  iv_level: '',
  iv_status: 1, //Active
  iv_full_name: '',
  iv_user_name: '',
  // iv_pin_code: '',
  iv_password: '',
  iv_confirm_password: '',
  iv_email: '',
  iv_phone_no: '',
  iv_cnic: '',
  iv_role: '',
  iv_company: '',
  iv_circle: '',
  iv_division: '',
  iv_support_center: '',
  iv_sub_division: '',
}
const UserCreateForm = () => {
  const [file, setFile] = useState("")
  const [hierarchyList, setHierarchyList] = useState([]);
  const [cfcsList, setcfcsList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subdivisionList, setsubDivisionList] = useState([]);
  const [circleCode, setCircleCode] = useState(0);
  const [level, setLevel] = useState(0)
  const [divisioncode, setDivisionCode] = useState(0);
  const [subdivisioncode, setsubDivisionCode] = useState(0);
  const [centerCscId, setcenterCscId] = useState(0);
  const [viewBackdrop, setViewBackdrop] = React.useState(false);
  const [companycode, setcompanycode] = useState(0)
  const [companyList, setCompanyList] = useState([]);
  const [error, setError] = useState('');
  const { token, code: userOfficeCode, permissions, userId, hierarchy } = useSelector((state) => state.auth)
  let userCompany = userOfficeCode.slice(0, 2);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [employeeType, setEmployeeType] = useState()
  

  const [technicalLevels, setTechnicalLevels] = useState([{
    value: 1,
    label: 'PITC'
  }, {
    value: 2,
    label: 'DISCO'
  }, {
    value: 3,
    label: 'Circle'
  }, {
    value: 4,
    label: 'Division'
  }, { 
    value: 52,
    label: 'Sub Division'
  }])

  useEffect(() => {
    if (hierarchy != 1) {
      let hierarchyArray = technicalLevels
      setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
      if (userCompany) {
        values.iv_company = String(userCompany)
      }
    }
  }, [hierarchy, userCompany])

  const navigate = useNavigate();

  useEffect(() => {
    if (userCompany) {
      var formdata = new FormData();
      // if (parseInt(userCompany) !== 11 && parseInt(userCompany) !== 12 && parseInt(userCompany) !== 13 && parseInt(userCompany) !== 15 && parseInt(userCompany) !== 26 && parseInt(userCompany) !== 37 && parseInt(userCompany) !== 38 && parseInt(userCompany) !== 48 && parseInt(userCompany) !== 59) {
      //   formdata.append("companyCode", 15);
      // } else {
        formdata.append("companyCode", parseInt(userCompany));
      // }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
          let hierarchyArray = result.message
          let sortedSdArray = hierarchyArray.sort(function (a, b) {
            var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (sdA < sdB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (sdA > sdB) {
              return 1; // nameA comes after nameB in the sorted order

            }
            return 0; // names are equal, their order doesn't matter
          });
          setHierarchyList(sortedSdArray)
          // handleChange(event.target.value);
          //values.iv_company = userCompany;
        }
        )
        .catch(error => console.log('error', error));
    }
  }, [])

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        cpList.unshift({ code: 10, name: 'PITC' })
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [token,cfpBaseUrl])

  useEffect(() => {
    const getAllEmployeeRoleTypes = async () => {
      setViewBackdrop(true)
      let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
      if (employeeRoleTypes) {
        setEmployeeType(employeeRoleTypes)
      }
      setViewBackdrop(false);
    }
    getAllEmployeeRoleTypes()
  }, [])

  const [allRoles, setAllRoles] = useState([]);

  useEffect(() => {
    const getAllRoles = async () => {
      let allroles = await AllRoles(token, permissions)
      setAllRoles(allroles)
    }
    getAllRoles()
  }, [])

  const loadCompanyHierarchy = async (companyCode) => {
    if (companyCode === '' || companyCode === undefined || companyCode === null) return
    const codeNum = parseInt(String(companyCode), 10)
    if (Number.isNaN(codeNum)) return
    var formdata = new FormData()
    formdata.append('companyCode', codeNum)
    const myHeaders = new Headers()
    myHeaders.append('Authorization', token)
    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    }
    try {
      const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions)
      const result = await response.json()
      const hierarchyArray = result.message
      if (!hierarchyArray || !Array.isArray(hierarchyArray)) return
      const sortedSdArray = hierarchyArray.sort(function (a, b) {
        var sdA = a.circleName.toUpperCase()
        var sdB = b.circleName.toUpperCase()
        if (sdA < sdB) return -1
        if (sdA > sdB) return 1
        return 0
      })
      setHierarchyList(sortedSdArray)
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleChangeCompany = async (event) => {
    if (event) {
      handleChange(event)
      const code = String(event.target.value)
      setcompanycode(code)
      values.iv_office_code = code
      setCircleCode(0)
      setDivisionCode(0)
      setsubDivisionCode(0)
      values.iv_company = code
      await loadCompanyHierarchy(code)
    }
  };

  const handleChangecircle = (event) => {
    handleChange(event);
    setCircleCode(event.target.value); // update the value state with the selected value
    const selectedCircle = circleList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    values.iv_office_code = selectedCircle.code;
    setDivisionCode(0)
    setsubDivisionCode(0)
  };

  const handleChangedivision = (event) => {
    handleChange(event);
    setDivisionCode(event.target.value); // update the value state with the selected value
    const selecteddivion = divisionList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    values.iv_office_code = selecteddivion.code;
    setsubDivisionCode(0)
    setcenterCscId(0);
  };

  const handleChangesubdivision = (event) => {
    handleChange(event);
    values.iv_office_code = event.target.value;
    setsubDivisionCode(event.target.value); // update the value state with the selected value

  };

  const handleChangecustomercenter = (event) => {
    console.log(event , 'event')
    handleChange(event);
    console.log(values.iv_office_code , 'values.iv_office_cod')

    values.iv_office_code = event.target.value;
    setcenterCscId(event.target.value); // update the value state with the selected value
  };

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniqueCircles = []

      for (let i = 0; i < hierarchyArray.length; i++) {
        const circle = hierarchyArray[i];
        const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
        if (!existingCircle) {
          uniqueCircles.push({
            code: circle.circleCode,
            name: circle.circleName
          });
        }
      }

      let sortedCircleArray = uniqueCircles.sort(function (a, b) {
        var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (circleA < circleB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (circleA > circleB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setCircleList(sortedCircleArray)
    }
  }, [hierarchyList])

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniqueDivisions = []

      for (let i = 0; i < hierarchyArray.length; i++) {
        const division = hierarchyArray[i];
        if (division.circleCode === circleCode) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (divisionA < divisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (divisionA > divisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setDivisionList(sortedDivisionArray)
    }
  }, [circleCode])

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniquesubDivisions = []
      for (let i = 0; i < hierarchyArray.length; i++) {
        const subdivision = hierarchyArray[i];
        if (subdivision.divisionCode === divisioncode) {
          const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
          if (!existingsubDivision) {
            uniquesubDivisions.push({
              code: subdivision.subDivisionCode,
              name: subdivision.subDivisionName
            });
          }
        }
      }

      let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
        var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (subdivisionA < subdivisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (subdivisionA > subdivisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setsubDivisionList(sortedsubDivisionArray)
    }
  }, [divisioncode])

  useEffect(() => {
    const AllCFCSAPI = async () => {
      setViewBackdrop(true)
      try {
        var formdata = new FormData();
        if (userOfficeCode == 10) {
          formdata.append("companyCode", '');
        } else {
          formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
        }
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              const allcfcs = result.data
              setcfcsList(allcfcs)
            }
          })
          .catch(error => console.log('error', error));
      }
      catch (e) {
      }
      setViewBackdrop(false)
    }
    AllCFCSAPI()
  }, [companycode, circleCode, divisioncode ,level])

  // const handleLevelChange = (event) => {
  //   console.log('event', event.target.value)
  //   console.log('values', values)
  //   console.log(hierarchy, 'hierarchy')
  //   handleChange(event)
  //   if (hierarchy == 1) {
  //     values.iv_role = '';
  //     if (event.target.value === 1) {
  //       console.log('inside 1')
  //       values.iv_company = 1
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = event.target.value
  //       setcompanycode(1);
  //     }
  //     else if (event.target.value === 2) {
  //       console.log('inside 2')
  //       values.iv_company = ''
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = 0
  //       setcompanycode('');
  //     }
  //     else if (event.target.value === 3) {
  //       console.log('inside 3')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 4) {
  //       console.log('inside 4')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 51) {
  //       console.log('inside 51')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_support_center = ''
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 52) {
  //       console.log('inside 52')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = ''
  //     }
  //   } else {
  //     if (event.target.value === 2) {
  //       values.iv_company = userCompany
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //       setcompanycode(userCompany);
  //     }
  //     else if (event.target.value === 3) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 4) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 52) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = userCompany
  //     }
  //   }
  // }
const handleLevelChange = (event) => {
  console.log("lsassadlsldsdlssasdj",event.target.value)
    setLevel(event.target.value)
    handleChange(event)
    // clear dependent fields whenever level changes
    values.iv_role = '';
    values.iv_company = '';
    values.iv_circle = '';
    values.iv_division = '';
    values.iv_support_center = '';
    values.iv_sub_division = '';
    values.iv_office_code = '';
    setcompanycode(0);
    setCircleCode(0);
    setDivisionCode(0);
    setsubDivisionCode(0);
    setcenterCscId(0);
    if (event.target.value === 1) {
      values.iv_company = 1
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = event.target.value
      console.log('I"m running for PITC')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
      setcompanycode(1);
    }
    else if (event.target.value === 2) {
      console.log("consolling2")
      // values.iv_company = ''
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = userOfficeCode.slice(0,2)
      console.log('I"m running For DISCO')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
      // setcompanycode('');
    }
    else if (event.target.value === 3) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_circle = ''
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 4) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_division = ''
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 51) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_support_center = ''
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 52) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_support_center = 0
      values.iv_sub_division = ''
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }

    // Non–super-admin users cannot pick Company (dropdown is disabled); keep their office company
    // and reload hierarchy whenever level changes, since handleLevelChange clears iv_company above.
    const levelForCompanyRule = parseInt(event.target.value, 10)
    if (
      parseInt(hierarchy, 10) !== 1 &&
      !Number.isNaN(levelForCompanyRule) &&
      levelForCompanyRule > 1 &&
      userCompany
    ) {
      const uc = String(userCompany)
      values.iv_company = uc
      setcompanycode(uc)
      void loadCompanyHierarchy(uc)
    }

  }
  const errorCloses = () => {
    setError('')
  }

  const { values, errors, touched, submitCount, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_type: Yup.mixed().required('Select user type.'),
      iv_office_code: Yup.string().optional(),
      iv_level: Yup.mixed().required('Level is required'),
      iv_status: Yup.mixed().required('Level is required'),
      iv_full_name: Yup.string().required("Fullname is required").min(2, `Name can't be less than 2 characters!`).max(50, `Name can't be more than 50 characters!`),
      iv_user_name: Yup.string()
  .required("Username is required")
  .matches(/^\S*$/, "Username must not contain spaces"),
      // iv_pin_code: Yup.number().typeError("Pincode must be in number").required("Pincode is required"),
      iv_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
      iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
      iv_email: Yup.string().email('Enter valid email!').required("Email is required"),
      iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
      iv_cnic: Yup.string().min(13, "CNIC no. can not less than 13 digits.").max(13, "CNIC no. can not greater than 13 digits.").required("CNIC No. is required").matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_role: Yup.mixed().required('Role is required'),
      iv_company: Yup.string().when('iv_level', {
        is: (value) => value > 1,
        then: Yup.string().required("Company is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.string().when('iv_level', {
        is: (value) => value > 2,
        then: Yup.string().required("Circle is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_division: Yup.string().when('iv_level', {
        is: (value) => value > 3,
        then: Yup.string().required("Division is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_support_center: Yup.mixed().when(['iv_level', 'iv_type'], (level, type, schema) => {
        if (parseInt(level) !== 1 && type === "1") {
          return schema.test('support-required', 'Customer Support Center is required!', function (value) {
            return value !== undefined && value !== null && value !== '' && value !== 0 && value !== '0';
          });
        }
        return schema.optional();
      }),
      iv_sub_division: Yup.string().when('iv_level', {
  is: (value) => value == 5 || value == 52,
  then: (schema) => schema.required("Sub division is required!"),
  otherwise: (schema) => schema.optional(),
}),
    }),
    onSubmit: async (values, { resetForm }) => {
      
      setViewBackdrop(true);
      var formdata = new FormData();

      formdata.append("name", values.iv_full_name);
      formdata.append("code", (values.iv_type == "1" && values.iv_level === 1) ? 10 : (companycode == "0" ? values.iv_office_code.toString().slice(0, 2) : values.iv_office_code));
      formdata.append("CNIC", values.iv_cnic);
      formdata.append("phoneNo", values.iv_phone_no);
      formdata.append("email", values.iv_email);
      formdata.append("toBeCreatedUserId", values.iv_user_name);
      formdata.append("password", values.iv_password);
      formdata.append("theme", "");
      formdata.append("is_super_admin", 0); 
      formdata.append("role_id", values.iv_role);
      formdata.append("hierarchy", values.iv_level);
      formdata.append("remember_token", 1);
      formdata.append("pin_code", "0000");
      formdata.append("status", values.iv_status);
      formdata.append("created_by", userId);
      formdata.append("updated_by", "");
      formdata.append("cscId", (centerCscId == "undefined" || centerCscId == "0") ? '' : centerCscId);
      formdata.append("statusRemarks", "");
      formdata.append("companyCode", (values.iv_type == "1" && values.iv_level === 1) ? 10 : (companycode == "0" ? values.iv_office_code.toString().slice(0, 2) : companycode));
      formdata.append("circleCode", circleCode);
      formdata.append("divisionCode", divisioncode);
      formdata.append("subDivisionCode", subdivisioncode);
      formdata.append("profilePicture", file);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/addUser", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            navigate('/user-management')
          }
          else {
            setViewBackdrop(false);
            setError(result.message)
          }
        })
        .catch(error => {
          setViewBackdrop(false);
        });
    }
  });

  useEffect(() => {
    if (values.iv_level) {
      if (values.iv_level === 1) {
        values.iv_office_code = 10
      }
    }
  }, [values.iv_level])

  useEffect(() => {
    if (values.iv_type) {
      values.iv_level = '';
      values.iv_role = '';
      values.iv_circle = '';
      values.iv_office_code = '';
      setCircleCode(0)
      values.iv_division = '';
      setDivisionCode(0)
      values.iv_sub_division = '';
      setsubDivisionCode(0)
      values.iv_support_center = '';
      setcenterCscId(0)
      if (hierarchy == 1) {
        values.iv_company = '';
        setcompanycode('');
      }
    }
  }, [values.iv_type])

  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const callCFCLevels = async () => {
      setViewBackdrop(true)
      let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
      if (cfcLevelsList) {
        if (hierarchy != 1) {
          cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
        }
        setCFCLevelList(cfcLevelsList)
      }
      setViewBackdrop(false);
    }
    callCFCLevels()
  }, [])

  return (
    <>
      <form autoComplete="off" onSubmit={handleSubmit} noValidate>
        <input type="text" name="prevent_autofill_username" style={{ display: 'none' }} />
        <input type="password" name="prevent_autofill_password" style={{ display: 'none' }} />
        <Grid
          container
          className='form-box'
          sx={{
            mx: { xs: '8px', sm: '14px', md: '20px' },
            width: 'auto',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
        <Grid item lg={12}>
          <h3 className='page-title'>
            Add New User
          </h3>
        </Grid>
        <Grid item lg={12} sx={{ margin: '15px 0px' }}>
          <Grid
            container
            sx={{
              backgroundColor: 'white',
              borderRadius: '10px',
              border: '1px solid lightgrey',
              padding: { xs: '8px', sm: '10px' },
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '100%',
              overflowX: 'hidden',
            }}
          >
            <Grid item lg={12} sx={{ height: 'max-content' }}>
              <Grid
                container
                sx={{
                  padding: "20px",
                  alignItems: { xs: "stretch", lg: "center" },
                }}
              >
                <Grid
                  item
                  lg={2}
                  xs={12}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: { xs: 2, lg: 0 },
                    pr: { lg: 2 },
                    pt: { lg: 4 },
                    pb: { lg: 2 },
                  }}
                >
                  <Box sx={{ position: "relative", width: 168, height: 168 }}>
                    <Box
                      component="img"
                      src={file ? URL.createObjectURL(file) : UserIconImage}
                      alt="Profile"
                      onError={(e) => {
                        e.target.src = UserIconImage;
                      }}
                      sx={{
                        width: 168,
                        height: 168,
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "4px solid #fff",
                        boxShadow:
                          "0 0 0 3px #006ad1, 0 10px 28px rgba(0, 106, 209, 0.28)",
                      }}
                    />
                    <Box
                      component="label"
                      htmlFor="create-user-profile-photo-input"
                      sx={{
                        position: "absolute",
                        right: -2,
                        bottom: -2,
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        bgcolor: "#006ad1",
                        color: "common.white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        border: "3px solid #fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        transition: "transform 0.15s, background-color 0.15s",
                        "&:hover": {
                          bgcolor: "#0056a8",
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <DriveFolderUploadIcon sx={{ fontSize: 26 }} />
                    </Box>
                    <input
                      type="file"
                      id="create-user-profile-photo-input"
                      accept="image/jpeg,image/png,.jpg,.jpeg,.png"
                      onChange={(e) => {
                        const picked = e.target.files[0];
                        if (!picked) return;
                        const isValidFileType =
                          picked.type === "image/jpeg" ||
                          picked.type === "image/png";
                        const isValidFileSize = picked.size <= 3 * 1024 * 1024;
                        if (!isValidFileType) {
                          alert("Only JPEG and PNG images are allowed");
                          e.target.value = "";
                          return;
                        }
                        if (!isValidFileSize) {
                          alert("File size must be less than 3MB");
                          e.target.value = "";
                          return;
                        }
                        setFile(picked);
                      }}
                      style={{ display: "none" }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 4, textAlign: "center", display: "block" }}
                  >
                    JPEG or PNG · max 3 MB
                  </Typography>
                </Grid>
                <Grid item lg={10} xs={12} sx={{ paddingLeft: { xs: 0, lg: "20px" } }}>
                  <Grid
                    container
                    sx={{
                      '& > .MuiGrid-item': {
                        width: { xs: '100%', sm: '50%', lg: '25%' },
                        maxWidth: { xs: '100%', sm: '50%', lg: '25%' },
                        flexBasis: { xs: '100%', sm: '50%', lg: '25%' },
                      },
                    }}
                  >
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Employee Type</label>
                      <Grid>
                        {
                          errors.iv_type && touched.iv_type ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_type}</p>
                          ) : null
                        }
                      </Grid>
                      <FormControl className='form-control' >
                        <RadioGroup
                          className='radio-group'
                          row
                          name="iv_type"
                          defaultValue={values.iv_type}
                          value={values.iv_type}
                          onChange={handleChange}
                        >
                          {employeeType && employeeType.map((item) => {
                            return <FormControlLabel
                              value={item.roleTypeId}
                              className='form-control-label'
                              control={<Radio />}
                              label={item.roleTypeName}
                              labelPlacement="end"
                            />
                          })}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                     <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Status</label>
                      <Grid>
                        {
                          errors.iv_status && touched.iv_status ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
                          ) : null
                        }
                      </Grid>
                      <FormControl className='form-control'>
                        <RadioGroup
                          className='radio-group'
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_status"
                          id="iv_status"
                          value={values.iv_status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <FormControlLabel
                            value={1}
                            className='form-control-label'
                            control={<Radio />}
                            label='Active'
                            labelPlacement="end"
                          />
                          <FormControlLabel
                            value={0}
                            className='form-control-label'
                            control={<Radio />}
                            label='Inactive'
                            labelPlacement="end"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                     <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Office Code</label>
                      <TextField type='number' maxLength='5' readOnly onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} disabled sx={{
                        backgroundColor: '#EEF1F7', width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                    </Grid>
                    {
                      values.iv_type == "1" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    } {
                      values.iv_type == "2" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    }


                    {/* <Grid item lg={3} sx={{ padding: '10px' }}></Grid> */}
                    {
                      values.iv_level > 1 ?
                        <>
                          <Grid item lg={3} sx={{ padding: '10px' }}>
                            <label>Company</label>
                            <Select
  fullWidth
  value={values.iv_company === '' || values.iv_company === undefined ? '' : String(values.iv_company)}
  disabled={parseInt(hierarchy) != 1}
  onChange={handleChangeCompany}
  sx={{ height: '45px' }}
  onBlur={handleBlur}
  name="iv_company"
  id="iv_company"
>
  <MenuItem value="">Select Company</MenuItem>
  {companyList
    .filter((item) => values.iv_level > 1 ? item.code > 1 : true)
    .map((item) => (
      <MenuItem key={item.code} value={String(item.code)}>
        {item.name}
      </MenuItem>
    ))}
</Select>

                            <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                              {errors.iv_company && touched.iv_company ? (errors.iv_company) : null}
                            </Grid>
                          </Grid>
                        </> : null
                    }
                    {
                      values.iv_level > 2 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Circle</label>
                          <Select
                            fullWidth
                            value={values.iv_circle}
                            onChange={handleChangecircle}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_circle"
                            id="iv_circle"
                          >
                            <MenuItem>Select Circle</MenuItem>
                            {
                              circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    {
                      values.iv_level > 3 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Division</label>
                          <Select
                            fullWidth
                            value={values.iv_division}
                            onChange={handleChangedivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_division"
                            id="iv_division"
                          >
                            <MenuItem>Select Division</MenuItem>
                            {
                              divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                   
                    {
                      (values.iv_level === 52 || values.iv_level == 5) ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Sub Division</label>
                          <Select
                            fullWidth
                            value={values.iv_sub_division}
                            onChange={handleChangesubdivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_sub_division"
                            id="iv_sub_division"
                          >
                            <MenuItem>Select Sub Division</MenuItem>
                            {
                              subdivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_sub_division && (touched.iv_sub_division || submitCount > 0) ? (errors.iv_sub_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                     {
                      (values.iv_type == "1" && values.iv_level !== 1) ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Customer Support Center</label>
                          <Select
                            fullWidth
                            value={values.iv_support_center}
                            onChange={handleChangecustomercenter}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_support_center"
                            id="iv_support_center"
                          >
                            <MenuItem>Select CFC</MenuItem>
                            {
                              cfcsList.map((item) => {
                                const levelMatch = item.cfcLevelId == values.iv_level;
                                let locationMatch = false;

                                if (values.iv_level == 2) {
                                  // Regional: match against selected company if available, otherwise current user's company prefix
                                  const companyToMatch = values.iv_company || (userOfficeCode ? userOfficeCode.toString().slice(0, 2) : '');
                                  locationMatch = item.companyCode == companyToMatch;
                                } else if (values.iv_level == 3) {
                                  locationMatch = item.circleCode == values.iv_circle;
                                } else if (values.iv_level == 4) {
                                  locationMatch = item.divisionCode == values.iv_division;
                                } else if (values.iv_level == 5 || values.iv_level == 52) {
                                  locationMatch = item.subDivisionCode == values.iv_sub_division;
                                }

                                if (levelMatch && locationMatch) {
                                  return (
                                    <MenuItem key={item.cfcId} value={item.cfcId}>{item.cfcName}</MenuItem>
                                  )
                                }
                                return null;
                              })
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_support_center && (touched.iv_support_center || submitCount > 0) ? (errors.iv_support_center) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} sx={{ height: 'max-content' }}>
              <Grid container spacing={1}>
                <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 30px', padding: '5px' }}>
                  <h4 style={{ color: '#006ad1' }}>
                    User Role
                  </h4>
                </Grid>
                <Grid item lg={12}>
                  <Grid
                    container
                    sx={{
                      padding: '0px 10px',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <Grid item xs={12} sx={{ padding: '0px 10px', pt: 0 }}>
                      <FormControl
                        fullWidth
                        sx={{
                          alignItems: 'flex-start',
                          ml: 0,
                          mt: 0,
                          pl: 0,
                          width: '100%',
                          maxWidth: '100%',
                          '& .MuiFormControlLabel-root': {
                            mr: { xs: 0.5, sm: 1 },
                          },
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={values.iv_role}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          sx={{
                            width: '100%',
                            maxWidth: '100%',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            columnGap: { xs: 0.5, sm: 1 },
                            rowGap: 1,
                            ml: 0,
                            pl: 0,
                            boxSizing: 'border-box',
                          }}
                        >
                          {allRoles && allRoles.map((item) => {
                            const level = values.iv_level;
                            const roleTypeId = values.iv_type;

                            const isWiringInspector = item.id === 1173 || item.id === 1174 || item.id === 1176 || item.id === 1175;
                            if (isWiringInspector) {
                              const companyCodePrefix = userOfficeCode ? parseInt(userOfficeCode.toString().slice(0,2)) : null;
                              const isAdminCompany10 = companyCodePrefix === 10;
                              const isHierarchy1 = parseInt(hierarchy) === 1;
                              if (!(isAdminCompany10 && isHierarchy1)) {
                                return null;
                              }
                            }

                            if (
                              (
                                level == 4 &&
                                (item.level == 4 || item.level == 51 ) &&
                                item.roleTypeId == roleTypeId
                              ) ||
                              (
                                level != 4 &&
                                item.level == level &&
                                item.roleTypeId == roleTypeId
                              )
                            ) {
                              return (
                                <FormControlLabel
                                  key={item.id}
                                  sx={{
                                    padding: '0px 22.5px',
                                    backgroundColor: 'white',
                                    borderRadius: '5px',
                                    marginLeft: '0px',
                                    marginRight: 0,
                                    border: '1px solid lightgrey',
                                    marginBottom: 0
                                  }}
                                  value={item.id}
                                  control={<Radio />}
                                  label={item.name}
                                />
                              );
                            }
                            return null;
                          })}
                        </RadioGroup>
                      </FormControl>
                      {values.iv_level && errors.iv_role && touched.iv_role ? (
                        <p style={{ color: '#f73232', fontSize: '1rem', margin: '8px 0 0 0' }}>{errors.iv_role}</p>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 30px', padding: '5px' }}>
                  <h4 style={{ color: '#006ad1' }}>
                    User Information
                  </h4>
                </Grid>
                <Grid item lg={12}>
                  <Grid
                    container
                    sx={{
                      padding: '0px 10px',
                      '& > .MuiGrid-item': {
                        width: { xs: '100%', sm: '50%', lg: '25%' },
                        maxWidth: { xs: '100%', sm: '50%', lg: '25%' },
                        flexBasis: { xs: '100%', sm: '50%', lg: '25%' },
                      },
                    }}
                  >
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Full Name</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_full_name" value={values.iv_full_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_full_name && touched.iv_full_name ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_full_name}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Username</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_user_name" value={values.iv_user_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />

                      {
                        errors.iv_user_name && touched.iv_user_name ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_user_name}</p>
                        ) : null
                      }

                    </Grid>
                    {/* <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Pin code</label>
                      <TextField type='text' autoComplete='off' maxLength='4' onChange={handleChange} name="iv_pin_code" value={values.iv_pin_code} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_pin_code && touched.iv_pin_code ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_pin_code}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid> */}
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Email Address</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_email" value={values.iv_email} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_email && touched.iv_email ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_email}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Phone No.</label>
                      <TextField type='text' maxLength='11' autoComplete='off' onChange={handleChange} inputProps={{ maxLength: 11 }} name="iv_phone_no" value={values.iv_phone_no} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_phone_no && touched.iv_phone_no ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_phone_no}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>CNIC No.</label>
                      <TextField type='text' maxLength="13" autoComplete='off' onChange={handleChange} name="iv_cnic" inputProps={{ maxLength: 13 }} value={values.iv_cnic} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_cnic && touched.iv_cnic ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_cnic}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password</label>
                      <TextField maxLength='16' type={showPassword ? 'text' : 'password'} autoComplete='new-password' onChange={handleChange} name="iv_password" value={values.iv_password} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end">

                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {errors.iv_password && touched.iv_password ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>
                            Password should:
                            <ul>
                              <li>have length between 8 to 16 characters.</li>
                              <li>contain at least 1 lower case letter.</li>
                              <li>contain at least 1 upper case letter.</li>
                              <li>contain at least 1 number.</li>
                              <li>contain at least 1 special character.</li>
                            </ul>
                          </p>
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password Confirmation</label>
                      <TextField
                        maxLength="16"
                        type={showConfirmPassword ? 'text' : 'password'}
                        autoComplete="new-password"
                        onChange={handleChange}
                        name="iv_confirm_password"
                        value={values.iv_confirm_password}
                        onBlur={handleBlur}
                        sx={{
                          width: '100%',
                          '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleClickShowConfirmPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {errors.iv_confirm_password && touched.iv_confirm_password ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_confirm_password}
                          </p>
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px',display:'flex',justifyContent:'center',alignItems:'center' }}>
                      <Button  variant="contained" size='large' sx={{width:'100%'}} type="submit">
                        Submit
                      </Button>
                    </Grid>
                    <Grid item lg={12} sx={{ margin: '0px 20px 0px 10px' }}>
                      {
                        error &&
                        <Error
                          error={error}
                          onClose={() => errorCloses()}
                          backgroundColor="#FFC0CB"
                          textColor="#bb0303"
                          iconColor="#bb0303"
                        />
                      }
                    </Grid>
                  </Grid>

                  {/* <Grid container sx={{ minHeight: '17.5vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>

                    <Grid item lg={12} sx={{ padding: '0px 10px', textAlign: 'right' }}>
                      <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
                        Submit
                      </Button>
                    </Grid>
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      </form>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  )
}

export default UserCreateForm